<template>
<div class="selectdb" v-if="dbList">
  <div class="db-wrap">
    <el-scrollbar wrap-class="list" wrap-style="color: red;" view-style="font-weight: bold;" view-class="view-box" :native="false">
      <div class="juzhong">数据库选择</div>
      <div v-for="( groupitem , index) in dbList" :key='index'>
        <div class="fu">
          <el-header  class="head">{{groupitem.DbGroupName}}</el-header>
          <el-main class="db-list">
            <button v-for="(item,index) of groupitem.databasesList" ref="gbjs"  @click="selectDb(item)" :key='index' :class="{selected:selectedDb&&selectedDb.customerName==item.customerName?true:false,dbitem:true}">
              {{item.customerName}}
            </button>
          </el-main>
        </div>
      </div>
      <div class='btn2'>
        <el-button  class="btn3"  @click="selectDbBtn()">确定</el-button>
      </div>
    </el-scrollbar>
  </div>
</div>
<div v-else-if="!dbList&&message" class="message">{{message}}</div>
<div v-else class="message">登录跳转中，请稍后....</div>
</template>
<script>
import { getListDb,testDb,getUserFreeSettings,setUserFreeSettings} from '@api/common';

export default {
  name: "changeFactory",
  data() {
    return {
      activeName: "1",
      dbList:null, // 用户可选数据库
      status:null,
      selectedDb:null, // 选中的数据库
      // bo1:true,
      userConfig:null, // 用户配置

      message:"",// 消息提示内容
    };
  },
  created() {
    this.getDbList(); //获取数据库列表
  },
  methods:{
    /* 选择数据库 */
    selectDb(item){
      this.selectedDb = item;
    },
    // 数据库选择确定按钮
    async selectDbBtn(){
      if(this.selectedDb){
        let dbStatus=await testDb(this.selectedDb.dburlname); // 测试数据库是否可用
        if(dbStatus.status == 200){
          // 更新数据库信息
          this.$store.commit('db',this.selectedDb);
          // 同步获取用户配置信息和站点信息,并更新vuex里面的内容 
          this.$store.dispatch("getUserConfig").then(()=>{
            let page=this.getQueryString("page");
            if(!page){
              page="realTimeForm";
            }
            this.$router.push({name:page});
          });
          // 保存用户选择的数据库
          let config=this.userConfig||{};
          config.defaultDb=this.selectedDb;
          // 远程保存用户配置
          setUserFreeSettings(JSON.stringify(config));
        }else{
          this.$message({
            showClose: true,
            message: '数据库不可用',
            type: 'error'
          });
        }
      }else{
         this.$message({
            showClose: true,
            message: '请选择数据库',
            type: 'warning'
          });
      }
    },
    /* 首次进入页面获取数据 */
    async getDbList(){
      let data =  await getListDb();
      let dbList=data.content;
      // 判断是否url中是否有数据库参数,如果有相关的参数，直接进入相应的数据库
      let dbname=this.getQueryString("dbname");
      if(dbname){
        for(let group of dbList){
          let databasesList=group.databasesList;
          for(let db of databasesList){
            let dburlname=db.dburlname;
            if(dbname==dburlname){
              this.selectedDb=db;
              this.selectDbBtn();
            }
          }
        }
        // 没有相应的权限
        if(!this.selectedDb){
          this.dbList=null;
          this.message="对不起，您无权访问该页面内容！";
        }
      }else{
        // 判断数据库个数,如果只有一个数据库则，直接进入
        let groupCount=Object.keys(dbList).length;
        if(groupCount==1){
          let dbgroup=dbList[Object.keys(dbList)[0]];
          let databasesList=dbgroup.databasesList;
          let dbCount=Object.keys(databasesList).length;
          if(dbCount==1){
            let db=databasesList[Object.keys(databasesList)[0]];
            this.selectedDb = db;
            this.selectDbBtn();
          }else{
            // 更新列表
            this.dbList=dbList;
          }
        }else{
          // 更新列表
          this.dbList=dbList;
          // 获取用户选中的默认数据库
          await this.getUserConfig();
        }
      }
    },
    // 获取用户配置
    getUserConfig(){
      getUserFreeSettings().then(data=>{
        if(data.status&&data.status==200&&data.content){
          let config=data.content;
          let defaultDb=config.defaultDb;
          if(defaultDb){
            this.selectedDb=defaultDb;
          }
          // 引用用户配置
          this.userConfig=config;
        }
      });
    },
    // 查询url参数
    getQueryString(name){
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
          return decodeURIComponent(r[2]);
      }
      return null;
    }
  }
};   
</script>
<style  lang='scss'>
.selectdb {
  flex-direction:column;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/db.jpg") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .db-list {  
    margin-top: -35px;
    padding: 0px;

    .selected{
      background: #4E84FF;
      color:#fff;
    }
  }

  .fu{
    overflow-y:"scroll";//去掉滚动条
    padding: 25px;
    justify-content: center;
    align-items: center;
  }
  .head{
    margin-top: -40px;
    color:#4E84FF;
    Justify-content:flex-start;
    padding: 0px;
    margin-bottom: 10px;
  }
  button{
    border: 1px solid ;
    margin :  3px;
    width: 130pt;
    height: 30pt;
    border-radius: 5pt;
    background: white;
  }
  .db-wrap{
    font-size:20px;
    display: flex;
    flex-direction:column;
    height: 90%;
    width: 80%;
    background: #FFFFFF;

    .btn3{
      color: #FFFFFF;
      background: #4E84FF;
    }
    .btn2{
      margin: auto;
      text-align: center;
    }
    .juzhong{
      display:flex;
      align-items:center;
      justify-content:center;
    }

    /**滚动条样式 */
    .el-scrollbar .el-scrollbar__wrap{
      overflow-x: hidden;
    }
    .el-scrollbar{
      height: 100%;
    }
  } 
}
.message{
  text-align: center;
  padding-top: 50px;
}

</style>
 